var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4ae1bf53ca755ade4e88455229bdfeec1009b3d8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["wwtr-nl@sitemind"]={id:"4ae1bf53ca755ade4e88455229bdfeec1009b3d8"};
      